import bindTable from './bindTable'
export default function () {
  const bindtb = bindTable.call(this)
  return [
    // 客户
    bindtb[1],
    // 编号
    bindtb[0],
    // 描述
    bindtb[4],
    // 创建时间
    {
      title: $t('public.table_create_time'),
      index: 'update_time',
      format: 'datetime'
    },
    // 操作
    {
      title: $t('integration.operation'),
      operation: [
        {
          type: 'edit',
          click: this.editRowFn
        },
        {
          type: 'detail',
          click: this.detailFn
        },
        {
          type: 'delete',
          tip: true,
          click: this.delRowFn
        }
      ]
    }
  ]
}

export const searchCondi = [
  {
    id: 1,
    text: $t('integration.trunk_number'),
    type: 'input',
    paramsName: 'name',
    isChooze: true
  },
  {
    id: 2,
    text: $t('integration.relay_type'),
    type: 'select',
    paramsName: 'type',
    isChooze: false,
    selectParam: []
  }
]
